module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "add-field fill-height",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "div-center-horizontally"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-container', {
    staticClass: "medium-div"
  }, [_c('v-layout', {
    staticClass: "header-row",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "div-center-vertically"
  }, [_c('p', {
    staticClass: "org-name"
  }, [_vm._v(_vm._s(_vm.organization))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "div-center-vertically div-right-horizontally"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    staticClass: "close-icon"
  }, [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "field-content-row",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('FieldEditor', {
    attrs: {
      "isNewField": _vm.isNewField,
      "fieldData": _vm.fieldData,
      "comesFromAnotherRoute": _vm.comesFromAnotherRoute,
      "comesFromAnotherRouteData": _vm.comesFromAnotherRouteData,
      "comesFromAnotherRouteName": _vm.comesFromAnotherRouteName
    },
    on: {
      "update:fieldData": function($event) {
        _vm.fieldData = $event
      },
      "update:field-data": function($event) {
        _vm.fieldData = $event
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eecf952","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Additions/AddField.vue
// module id = 1741
// module chunks = 0